import { useQuery } from '@tanstack/react-query';
import { QueryStatus } from '@/shared/ui/QueryStatus';
import { fetchMetrikaFilters, fetchUtms, updateUtm } from './api';
import { MetrikaSelectCell } from './MetrikaSelectCell';

const QUERY_KEY = 'metrika-utm';

export const MetrikaUtmTab = () => {
  const filters = useQuery({ queryKey: ['metrika-filters'], queryFn: fetchMetrikaFilters });
  const utms = useQuery({ queryKey: [QUERY_KEY], queryFn: fetchUtms });

  return (
    <div className="box">
      <div className="box-body">
        <QueryStatus
          isLoading={utms.isLoading}
          error={utms.error}
          errorText="Ошибка загрузки меток"
        />
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>ID</th>
              <th>Тег</th>
              <th>Значение</th>
              <th>Источник трафика</th>
            </tr>
          </thead>
          <tbody>
            {utms.data?.map((utm) => (
              <tr key={utm.id}>
                <td>{utm.id}</td>
                <td>{utm.utm_type}</td>
                <td>{utm.name}</td>
                <td>
                  <MetrikaSelectCell
                    value={String(utm.source_type ?? '')}
                    options={filters.data?.sources ?? []}
                    placeholder="источник трафика"
                    queryKey={QUERY_KEY}
                    save={(sourceId) => updateUtm(utm.id, sourceId)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
